<template>
  <div style="min-height:600px">
    <!--content-->
    <a-row type="flex" justify="center" align="top">
      <!--      carousel-->
      <a-col :span="24" :sm="24" :md="16">
        <a-carousel autoplay>
          <template v-for="item in slides">
            <img :src="item.image" alt="" @click="goNewsOrActivity($event, item.news, item.activity)">
          </template>
        </a-carousel>
      </a-col>
      <a-col :span="24" :sm="24" :md="8" style="padding:0 20px">
        <div>
          <h3
            style="border-bottom:2px solid var(--primaryColor); height:48px; line-height:48px; color:var(--primaryColor)">
            SCF简介</h3>
          <!-- <div v-html="scfInfo.brif"></div> -->
	  <div v-if="someData && someData.brif">
		  {{ scfInfo.brif }}
	  </div>
        </div>
      </a-col>

    </a-row>
    <a-row>
      <!--activities-->
      <a-col :span="24" :sm="24" :md="16">

        <a-card title="新闻" style="padding: 0 20px;height: 350px"
                :headStyle="{borderBottomWidth:'2px',borderBottom:'solid',borderBottomColor:'#246caf',color:'#246caf',fontWeight:'bolder'}">
          <a slot="extra" href="#">查看更多</a>
          <template v-for="item in news">
            <p style="overflow:hidden;">
              <router-link :to="{name:'newsInfo', params:{id:item.id}}">{{ item.name }}</router-link>
            </p>
          </template>

        </a-card>

      </a-col>
      <!--calendar-->
      <a-col :span="24" :sm="24" :md="8">
        <div :style="{ width: '100%', border: '1px solid #d9d9d9', borderRadius: '4px' }">
          <a-calendar :fullscreen="false" :header-render="headerRender" @panelChange="onPanelChange" @select="selectChange">
            <template slot="dateCellRender" slot-scope="value">
              <a-badge status="error" v-if="getDateData(value)"></a-badge>
            </template>

            <template slot="monthCellRender" slot-scope="value">
              <a-badge status="error" v-if="getMonthData(value)"></a-badge>
            </template>
          </a-calendar>
        </div>
      </a-col>


    </a-row>
    <template v-if="activities.length>0">
      <a-card title="活动" style="padding: 0 20px;height: 350px"
              :headStyle="{borderBottomWidth:'2px',borderBottom:'solid',borderBottomColor:'#246caf',color:'#246caf',fontWeight:'bolder'}">
        <a slot="extra" href="#">查看更多</a>
        <template v-for="item in activities">
          <p style="overflow:hidden;">
            <router-link :to="{name:'activityInfo', params:{id:item.id}}">{{ item.name }}</router-link>
          </p>
        </template>

      </a-card>
    </template>


  </div>


</template>

<script>
import {domain, getActivityList, getMemberList, getNewsList, getSlideList, getSocietyList} from "../../api/api";
import {filterUnderLine} from "../../../static/js/util";


export default {
  name: "index",
  methods: {
    onPanelChange(value, mode) {
      console.log(value, mode);
    },
    headerRender({value, type, onChange, onTypeChange}) {
      const start = 0;
      const end = 12;
      const monthOptions = [];

      const current = value.clone();
      const localeData = value.localeData();
      const months = [];
      for (let i = 0; i < 12; i++) {
        current.month(i);
        months.push(localeData.monthsShort(current));
      }

      for (let index = start; index < end; index++) {
        monthOptions.push(
          <a-select-option class="month-item" key={`${index}`}>
            {months[index]}
          </a-select-option>,
        );
      }
      const month = value.month();

      const year = value.year();
      const options = [];
      for (let i = year - 10; i < year + 10; i += 1) {
        options.push(
          <a-select-option key={i} value={i} class="year-item">
            {i}
          </a-select-option>,
        );
      }
      return (
        <div style={{padding: '10px'}}>
          <h3 style={{marginBottom: '10px', fontWeight: 'bold', color: '#246caf'}}>活动日历 </h3>
          <a-row type="flex" justify="space-between">
            <a-col>
              <a-radio-group size="small" onChange={e => onTypeChange(e.target.value)} value={type}>
                <a-radio-button value="month">月</a-radio-button>
                <a-radio-button value="year">年</a-radio-button>
              </a-radio-group>
            </a-col>
            <a-col>
              <a-select
                size="small"
                dropdownMatchSelectWidth={false}
                class="my-year-select"
                onChange={newYear => {
                  const now = value.clone().year(newYear);
                  onChange(now);
                }}
                value={String(year)}>
                {options}
              </a-select>
            </a-col>
            <a-col>
              <a-select
                size="small"
                dropdownMatchSelectWidth={false}
                value={String(month)}
                onChange={selectedMonth => {
                  const newValue = value.clone();
                  newValue.month(parseInt(selectedMonth, 10));
                  onChange(newValue);
                }}
              >
                {monthOptions}
              </a-select>
            </a-col>
          </a-row>
        </div>
      );
    },
    getDateData(value) {
      if ([1, 4, 8].includes(value.date())) {
        return true
      }
    },
    getMonthData(value) {

      console.log('getmonth===', value.month())
      if ([1, 4, 8].includes(value.month())) {
        return true
      }
    },
    selectChange(value){
      console.log(value.format('YYYY-MM-DD'))
    },

    goNewsOrActivity(e, newsId, activityId) {
      if (activityId !== null) {
        this.$router.push({name: 'activityInfo', params: {id: activityId}})
      } else if (newsId !== null) {
        this.$router.push({name: 'newsInfo', params: {id: newsId}})
      }
    }
  },
  data() {
    return {
      slides: [],
      activities: [],
      members: [],
      society: [],
      scfInfo: '',
      news:[]
    }
  },
  mounted() {

    getSlideList().then(res => {
      this.slides = filterUnderLine(res.data)
    }).catch((err) => {
      console.log(err)
    })
    getNewsList().then(res=>{

      this.news = filterUnderLine(res.data.results.slice(0,8))
    }).catch((err) => {
      console.log(err)
    })

    getActivityList().then(res => {
      this.activities = filterUnderLine(res.data.results.slice(0,8))
    }).catch((err) => {
      console.log(err)
    })

    getSocietyList({name:'SCF简介'}).then(res => {
      this.scfInfo = filterUnderLine(res.data)[0]
    }).catch((err) => {
      console.log(err)
    })
  }
}
</script>

<style scoped>
.logo {
  width: 380px;
  height: 60px;
  margin: 10px 10px;
  float: left;
}

.header {
  background-color: white;
}
a {
  color: black;
}
a:hover {
  color: var(--primaryColor);
}
a:active{
  color:blue;
}


</style>



// WEBPACK FOOTER //
// src/components/content/index.vue